import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import withContent from '../../../../containers/withContent';
import { getBacsDetailsWithAccounts } from '../../../../states/bacsCredit/selectors';
import bacsSummaryContent, { contentPropTypes } from '../BacsSummary.content';
import BacsSummary from '../BacsSummary';

const mapState = (state) => ({
	bacsDetails: getBacsDetailsWithAccounts(state),
});

const CreditSummary = ({ bacsDetails, content }) => (
	<BacsSummary
		bacsTypeHeader="Bacs Credit"
		dateLabel={content.settlementDateLabel}
		accountLabel={content.fromLabel}
		account={bacsDetails.from}
		bacsDetails={bacsDetails}
		content={content}
	/>
);

CreditSummary.propTypes = {
	bacsDetails: PropTypes.shape({}).isRequired,
	content: PropTypes.shape(contentPropTypes).isRequired,
};

const contentWrapper = withContent({ content: bacsSummaryContent });
export default connect(mapState)(contentWrapper(CreditSummary));
